module.exports = __webpack_public_path__ + "img/kommune-237.40a357ac.svg";